import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import StatCounter from "./StatCounter";

const StatCard = ({ stat, index, isFirst }) => {
  const BoxMotion = motion(Box);

  return (
    <BoxMotion
      custom={index}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.6,
            delay: index * 0.2,
          },
        },
      }}
      sx={{
        backgroundColor: isFirst ? "#000" : "#fff",
        color: isFirst ? "#fff" : "#000",
        border: isFirst ? "3px solid #fff" : "none",
        borderRadius: "35px",
        padding: { xs: "29px", md: "32px 24px" },
        width: {
          xs: "90%",
          sm: "80%",
          md: "24%",
        },
        height: { md: "180px" },
        margin: { xs: "0 auto", md: 0 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-6px)",
        },
      }}
    >
      <StatCounter
        value={stat.number}
        index={index}
        className="orbitron-font"
        sx={{
          fontSize: {
            xs: "28px",
            sm: "36px",
            md: "48px",
          },
          color: isFirst ? "#fff" : "#000",
          mb: 1,
          letterSpacing: "0.8px",
          lineHeight: 1,
          fontFamily: "'Orbitron', sans-serif",
        }}
      />

      <Typography
        variant="body1"
        sx={{
          fontFamily: "'Inter', 'Roboto', sans-serif",
          fontWeight: "500",
          fontSize: { xs: "12px", sm: "14px", md: "16px" },
          textAlign: "center",
          color: isFirst ? "#fff" : "#000",
          mb: stat.description ? 0.5 : 0,
        }}
      >
        {stat.title}
      </Typography>

      {stat.description && (
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Inter', 'Roboto', sans-serif",
            fontSize: "12px",
            textAlign: "center",
            color: "rgba(255, 255, 255, 0.7)",
            mt: 0.5,
            lineHeight: 1.4,
            maxWidth: "85%",
          }}
        >
          {stat.description}
        </Typography>
      )}
    </BoxMotion>
  );
};

export default StatCard;
